module.exports = __webpack_public_path__ + "static/img/liantu.0de15f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/liantu.png
// module id = x/19
// module chunks = 30